import { render } from "./RouletteTable.vue?vue&type=template&id=1a784c00&scoped=true"
import script from "./RouletteTable.vue?vue&type=script&lang=js"
export * from "./RouletteTable.vue?vue&type=script&lang=js"

import "./RouletteTable.vue?vue&type=style&index=0&id=1a784c00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a784c00"]])

export default __exports__